import {IToken} from "@/module/user";

class Store
{
    constructor(public token?: IToken,
                public env?: string,
                public envType?: string,
                public envBrand?: string,
                public financedSubjectType?: string,
                public clientType?: string,
                public orderType?: string,
                public financingType?: string,
                public cashFinancingType?: string,
                public showQrCode?: boolean,
                public copyToClipboard?: boolean,
                public walletWithOrder?: string,
                public financingApiVersion?: string,
                public carLoanType?: string)
    {
    }
}

export default Store;
